import React, { useState } from "react";
import {
  Box,
  TextField,
  Switch,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Grid,
  Typography,
  FormControlLabel,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import "./ProvidentFund.css";

const ProvidentFund = () => {
  const [pfEnabled, setPfEnabled] = useState(false);
  const [editable, setEditable] = useState(false);

  const [form, setForm] = useState({
    statutoryAmount: 15000,
    employeePFContribution: "",
    effectiveDate: "",
    enableCeiling: false,
    lopDependant: false,
    pfIncludedInCTC: false,
    edsliIncluded: false,
  });

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const handleSave = () => {
    console.log("PF Settings Saved:", form);
    setEditable(false);
  };

  return (
    <div className="pf-wrapper">
      <div className="pf-card">
        {/* Header */}
        <div className="pf-header">
          <Typography className="pf-title">Provident Fund (PF)</Typography>

          <FormControlLabel
            control={
              <Switch
                checked={pfEnabled}
                onChange={(e) => {
                  setPfEnabled(e.target.checked);
                  setEditable(false);
                }}
              />
            }
            label={pfEnabled ? "Enabled" : "Disabled"}
          />
        </div>

        {/* Body */}
        {pfEnabled && (
          <div className="pf-body">
            {/* Row 1 */}
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Statutory Minimum Amount"
                  value={form.statutoryAmount}
                  disabled={!editable}
                  onChange={(e) =>
                    handleChange("statutoryAmount", e.target.value)
                  }
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₹</InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl fullWidth disabled={!editable}>
                  <InputLabel>Employee PF Contribution</InputLabel>
                  <Select
                    value={form.employeePFContribution}
                    label="Employee PF Contribution"
                    onChange={(e) =>
                      handleChange("employeePFContribution", e.target.value)
                    }
                  >
                    <MenuItem value="Basic*12%">Basic × 12%</MenuItem>
                    <MenuItem value="Basic+Special*12%">
                      Basic + Special Allowance × 12%
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  label="Effective Date"
                  type="date"
                  value={form.effectiveDate}
                  disabled={!editable}
                  onChange={(e) =>
                    handleChange("effectiveDate", e.target.value)
                  }
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>

            {/* Row 2 */}
            <Grid container spacing={3} className="pf-switches">
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={form.enableCeiling}
                      disabled={!editable}
                      onChange={(e) =>
                        handleChange("enableCeiling", e.target.checked)
                      }
                    />
                  }
                  label="Enable Statutory Ceiling"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={form.lopDependant}
                      disabled={!editable}
                      onChange={(e) =>
                        handleChange("lopDependant", e.target.checked)
                      }
                    />
                  }
                  label="LOP Dependant"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={form.pfIncludedInCTC}
                      disabled={!editable}
                      onChange={(e) =>
                        handleChange("pfIncludedInCTC", e.target.checked)
                      }
                    />
                  }
                  label="PF Included in CTC"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={form.edsliIncluded}
                      disabled={!editable}
                      onChange={(e) =>
                        handleChange("edsliIncluded", e.target.checked)
                      }
                    />
                  }
                  label="Include EDSLI & Admin Charges"
                />
              </Grid>
            </Grid>

            {/* Actions */}
            <div className="pf-actions">
              {!editable ? (
                <IconButton
                  className="pf-edit-btn"
                  onClick={() => setEditable(true)}
                >
                  <EditIcon />
                </IconButton>
              ) : (
                <>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => setEditable(false)}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProvidentFund;
